import { useStore } from "..";

export const usePreview = () => useStore(({ preview }) => preview);
